import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// components
import { Navbar1 } from 'components/navbars';
import { Footer1 } from 'components/footer';
import BackToTop from 'components/BackToTop';

import Hero from './Hero';
import BlogPost2 from './BlogPost2';

import { Post1 } from 'components/blog';
// images
import hero from 'assets/images/blog/hero.jpg';
import { getAllBlogs, getSEODataList } from 'helpers/api/BlogService';
import { useEffect, useState } from 'react';
import { usePageTracking } from 'helpers/usePageTracking';
import Seo from 'components/Seo';
import Dropdown from 'react-bootstrap/Dropdown';

import FeatherIcon from 'feather-icons-react';
import { colors } from 'styles/colors';
import { FileText } from 'lucide-react';
interface BlogPost {
    id: number;
    blogTitle: string;
    shortDescription: string;
    status: number;
    blogTags: string;
    blogImage: string;
    createdOn: string;
    metaKeywords: string,
    slug: string;
}

const Blog = () => {

    const [allBlogList, setAllBlogList] = useState<Post1[]>([]);
    const [selectedTag, setSelectedTag] = useState<string | null>(null);
    const [seoTitle, setSeoTitle] = useState("");
    const [seoDescription, setSeoDescription] = useState("");
    const [seoKeywords, setSeoKeywords] = useState("");
    const seo = usePageTracking("blogs");

    useEffect(() => {
        const fetchSEO = async () => {
            try {
                const res = await getSEODataList();

                if (res?.success && Array.isArray(res.result)) {
                    // find SEO for blogsDetails
                    const seo = res.result.find(
                        (item: any) => item.pageName === "blogsDetails"
                    );

                    if (seo) {
                        setSeoTitle(seo.pageTitle);
                        setSeoDescription(seo.seoMetaDescription);
                        setSeoKeywords(seo.seoMetaKeywords);
                    }
                }
            } catch (err) {
                console.error("SEO load failed", err);
            }
        };

        fetchSEO();
    }, []);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await getAllBlogs();
                if (response?.success && Array.isArray(response.result)) {
                    const activeBlogs = response.result.filter((blog: any) => blog.status === 1 && blog.isBlog === true);


                    const transformedData: Post1[] = activeBlogs.map((blog: any) => ({
                        id: blog.id,
                        title: blog.blogTitle,
                        description: blog.shortDescription,
                        image: `${blog.blogImage}`,
                        tag: blog.blogTags,
                        createdOn: blog.createdOn,
                        metaKeywords: blog.metaKeywords,
                        slug: blog.slug
                    }));
                    setAllBlogList(transformedData);
                } else {
                    console.error('Invalid response format:', response);
                }
            } catch (error) {
                console.error('Failed to fetch blogs:', error);
            }
        };
        fetchBlogs();
    }, []);

    const uniqueTags = Array.from(
        new Set(
            allBlogList
                .flatMap(post =>
                    post.tag
                        ?.split(",")
                        .map(t => t.trim())
                        .filter(Boolean)
                )
        )
    );

    const filteredBlogs = selectedTag
        ? allBlogList.filter(post =>
            post.tag
                ?.split(",")
                .map(t => t.trim())
                .includes(selectedTag)
        )
        : allBlogList;

    return (
        <>
            {seo && (
                <Seo
                    pageName="blogs"
                    title={seoTitle}
                    description={seoDescription}
                    keywords={seoKeywords}
                    url="https://www.salestrackify.com/blogs"
                    image="/seo/trackify-preview.png"
                />
            )}
            <div
                className="header-7"
                style={{
                    background: `linear-gradient(160deg, rgba(36,52,125,0.92) 0%, rgba(38,162,171,0.85) 100%), url(${hero})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-dark "
                    buttonClass="btn-white text-white btn-sm"
                />
                <Hero />
            </div>

            <section
                className="position-relative"
                style={{
                    paddingTop: 'clamp(2rem, 4vw, 3.5rem)',
                    paddingBottom: 'clamp(2rem, 4vw, 3rem)',
                    background: '#f8fafb',
                    minHeight: '60vh',
                }}
            >
                <div style={{ marginLeft: 'clamp(1rem, 5%, 5%)', marginRight: 'clamp(1rem, 5%, 5%)' }}>
                    {/* Breadcrumb */}
                    <nav aria-label="breadcrumb" className="mb-4">
                        <ol className="breadcrumb" style={{ background: 'transparent', padding: 0, margin: 0, fontSize: '0.85rem' }}>
                            <li className="breadcrumb-item">
                                <Link to="/" style={{ color: colors.primary.teal, textDecoration: 'none', fontWeight: 500 }}>Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page" style={{ color: '#6b7280' }}>
                                Blogs
                            </li>
                        </ol>
                    </nav>

                    {/* Filter bar */}
                    <Row className="align-items-center mb-4">
                        <Col xs={12} md={6} className="mb-3 mb-md-0">
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant=""
                                    id="dropdown-basic"
                                    className="d-flex align-items-center gap-2"
                                    style={{
                                        background: '#fff',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '10px',
                                        padding: '10px 18px',
                                        fontSize: '0.9rem',
                                        fontWeight: 500,
                                        color: colors.primary.darkBlue,
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                                        transition: 'border-color 0.2s',
                                    }}
                                >
                                    <FeatherIcon icon="filter" size={16} style={{ color: colors.primary.teal }} />
                                    <span>{selectedTag ? selectedTag : "All Categories"}</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                    style={{
                                        borderRadius: '10px',
                                        border: '1px solid #e5e7eb',
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                        padding: '6px',
                                    }}
                                >
                                    <Dropdown.Item
                                        onClick={() => setSelectedTag(null)}
                                        style={{ borderRadius: '6px', fontSize: '0.88rem' }}
                                    >
                                        All Categories
                                    </Dropdown.Item>
                                    {uniqueTags.map((tag, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => setSelectedTag(tag ?? null)}
                                            style={{ borderRadius: '6px', fontSize: '0.88rem' }}
                                        >
                                            {tag}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col xs={12} md={6} className="text-md-end">
                            <span
                                style={{
                                    fontSize: '0.88rem',
                                    fontWeight: 500,
                                    color: '#6b7280',
                                }}
                            >
                                Showing{' '}
                                <strong style={{ color: colors.primary.darkBlue }}>
                                    {filteredBlogs.length}
                                </strong>{' '}
                                article{filteredBlogs.length !== 1 ? 's' : ''}
                            </span>
                        </Col>
                    </Row>

                    {/* Blog grid */}
                    <Row className="mt-2" data-aos="fade-up">
                        {filteredBlogs.length > 0 ? (
                            filteredBlogs.map((post) => (
                                <Col xs={12} sm={6} lg={4} className="mb-4" key={post.id}>
                                    <BlogPost2 Post1={post} />
                                </Col>
                            ))
                        ) : (
                            <Col xs={12}>
                                <div
                                    className="text-center py-5"
                                    style={{
                                        background: '#fff',
                                        borderRadius: '16px',
                                        border: '1px solid #e5e7eb',
                                    }}
                                >
                                    <FileText size={48} style={{ color: '#d1d5db' }} className="mb-3" />
                                    <p style={{ color: '#6b7280', fontSize: '1rem', margin: 0 }}>
                                        No blog posts available for the selected category.
                                    </p>
                                </div>
                            </Col>
                        )}
                    </Row>
                </div>
            </section>

            {/* Explore SalesTrackify interlink section */}
            <section style={{ padding: '48px 0', background: '#fff', borderTop: '1px solid #f0f0f0' }}>
                <div style={{ marginLeft: 'clamp(1rem, 5%, 5%)', marginRight: 'clamp(1rem, 5%, 5%)' }}>
                    <div className="d-flex align-items-center mb-4" style={{ gap: '10px' }}>
                        <span style={{ width: '32px', height: '3px', background: colors.primary.teal, display: 'inline-block', borderRadius: '2px' }} />
                        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: colors.primary.darkBlue, margin: 0 }}>Explore SalesTrackify</h2>
                    </div>
                    <Row>
                        {[
                            { to: '/features', label: 'Features', desc: 'Discover all CRM features built to supercharge your sales team.', icon: 'features' },
                            { to: '/industries', label: 'Industries', desc: 'See how SalesTrackify fits your industry and business model.', icon: 'briefcase' },
                            { to: '/about', label: 'About Us', desc: 'Learn about our mission to make sales management effortless.', icon: 'users' },
                            { to: '/contact', label: 'Contact Us', desc: 'Get in touch and our team will be happy to help you get started.', icon: 'mail' },
                        ].map(({ to, label, desc, icon }) => (
                            <Col xs={12} sm={6} lg={3} className="mb-4" key={to}>
                                <Link
                                    to={to}
                                    className="text-decoration-none d-flex flex-column h-100"
                                    style={{
                                        background: '#f8fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '12px',
                                        padding: '20px 22px',
                                        transition: 'box-shadow 0.25s ease, border-color 0.25s ease, transform 0.25s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(38,162,171,0.12)';
                                        (e.currentTarget as HTMLElement).style.borderColor = colors.primary.teal;
                                        (e.currentTarget as HTMLElement).style.transform = 'translateY(-3px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                                        (e.currentTarget as HTMLElement).style.borderColor = '#e5e7eb';
                                        (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                                    }}
                                >
                                    <FeatherIcon icon={icon} size={22} style={{ color: colors.primary.teal, marginBottom: '8px' }} />
                                    <span style={{ fontWeight: 700, fontSize: '1rem', color: colors.primary.darkBlue, marginBottom: '6px' }}>{label}</span>
                                    <span style={{ fontSize: '0.84rem', color: '#6b7280', lineHeight: 1.6 }}>{desc}</span>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            <Footer1 />
            {/* <BackToTop /> */}
        </>
    );
};

export default Blog;
